<template>
  <b-row>
    <b-col v-for="(page, index) of wordpressData" :key="index">
      <div v-if="page && page.content">
        <div v-html="page.content.rendered"></div>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import wpMixin from 'vue-wordpress/src/mixins/wp-mixin'
// import WordpressPost from '@/components/elements/WordpressPost'
import { WordpressCall } from '@/common/api.service'

export default {
  name: 'WordpressFeed',
  components: {
    //WordpressPost,
  },
  mixins: [wpMixin],
  data() {
    return {
      wordpressResponse: null,
    }
  },
  computed: {
    wordpressData() {
      if (typeof this.wordpressResponse === 'object') return [this.wordpressResponse]
      return this.wordpressResponse
    },
  },
  async mounted() {
    const { data } = await WordpressCall.get()
    this.wordpressResponse = data
  },
}
</script>
